import {useEffect, useState} from 'react';

let profileState = null;
let profileSetters = [];

export const setGlobalProfile = (profile) => {
    profileState = profile;
    profileSetters.forEach(setter => setter(profile));
};

export const useProfile = () => {
    const [profile, setProfile] = useState(profileState);

    useEffect(() => {
        profileSetters.push(setProfile);
        return () => {
            profileSetters = profileSetters.filter(setter => setter !== setProfile);
        };
    }, []);

    return profile;
};

export const clearGlobalProfile = (): void => {
    setGlobalProfile(null);
};
